import StyledDialog from "components/Styled/Dialog";

interface Props {
  children: React.ReactNode;
  handleClose?: () => void;
  isDialog?: boolean;
  dialogTitle?: string;
}

const CreateTemplateDialogWrapper = ({
  children,
  handleClose,
  isDialog,
  dialogTitle = "",
}: Props) => {
  if (!isDialog) {
    return <>{children}</>;
  }
  return (
    <StyledDialog
      title={dialogTitle}
      open={true}
      handleClose={handleClose}
      maxWidth="lg"
    >
      {children}
    </StyledDialog>
  );
};

export default CreateTemplateDialogWrapper;
